/// ///////////////////////////////////////////////////////////////////////////
//  Copyright (C) 2013 by sanpolo CO.LTD                                    //
//                                                                          //
//  This file is part of WIDE                                               //
//                                                                          //
//  You should have received a copy of the WIDE License along with this     //
//  program.  If not, see <http://www.wware.org/wide/license.html>.         //
//                                                                          //
//  WIDE website: http://www.wware.org/                                     //
/// ///////////////////////////////////////////////////////////////////////////
// Created At : 2019-03-05T12:35:52.090Z by lizhutang (lizhutang@spolo.org)

'use strict'

import ckeditor from './ckeditor'
// import summernote from './summernote'
// import stylebind from './stylebind'
// import domComponents from './domComponents'
import styleManager from './styleManager'
import store from './store'
import layer from './ui/layer'
import components from './ui/componets'

let grapesjs

function onEditorLoaded (wwInst) {
  wwInst.editorLoaded = true
  // @TODO add mask here.并增加结束回调以移除loading mask.
}

function initGrapes (wwInst) {
  if (!grapesjs) {
    grapesjs = window.grapesjs
    // console.log(grapesjs)
  }
  wwInst.editor = grapesjs.init({
    avoidInlineStyle: 1,
    height: '100%',
    showOffsets: 1,
    selectorManager: {
      label: wwjs.i18n('样式类'),
      selectedLabel: wwjs.i18n('选择器:'),
      // Label for states
      statesLabel: wwjs.i18n('- 默认状态 -'),
      states: [
        { name: 'hover', label: wwjs.i18n('鼠标划过') },
        { name: 'active', label: '鼠标点击' },
        { name: 'nth-of-type(2n)', label: '(偶数/奇数)位置' }
      ]
    },
    assetManager: {
      addBtnText: wwjs.i18n('添加图片'),
      modalTitle: wwjs.i18n('选择素材'),
      upload: '/v/setassets.json',
      uploadText: wwjs.i18n('拖动素材到这里或点击选择素材，以将素材加入到素材库'),
      embedAsBase64: 0
      // dropzone: 1,
      // dropzoneContent: `<div class="dropzone-inner">Drop here your assets</div><div>test</div>`
    },
    styleManager: {
      textNoElement: wwjs.i18n('请选择一个元素以编辑此元素的<b>样式</b>'),
      clearProperties: 1
    },
    traitManager: {
      textNoElement: wwjs.i18n('请选择一个元素以编辑此元素的<b>功能属性</b>'),
      labelContainer: wwjs.i18n('元素功能设置')
    },
    storageManager: {
      type: 'wwstorage',
      autosave: false,
      autoload: true
    },
    noticeOnUnload: 0,
    container: wwInst.$ele.get(0),
    fromElement: true,
    showDevices: false,
    plugins: ['gjs-preset-webpage',
      'grapesjs-custom-code',
      'grapesjs-parser-postcss',
      'grapesjs-tooltip',
      'grapesjs-wwclass-bootstrap4',
      'grapesjs-wwclass-layerjs'
    ],
    pluginsOpts: {
      'grapesjs-tooltip': { /* options */ },
      'gjs-preset-webpage': {
        modalImportTitle: wwjs.i18n('导入模板'),
        modalImportLabel: `<div style="margin-bottom: 10px; font-size: 13px;">${wwjs.i18n('将模板内容拷贝到下方，并点击《导入》')}</div>`,
        modalImportContent: function (editor) {
          return editor.getHtml() + '<style>' + editor.getCss() + '</style>'
        },
        filestackOpts: null, // { key: 'AYmqZc2e8RLGLE7TGkX3Hz' },
        aviaryOpts: false,
        showStylesOnChange: false,
        blocksBasicOpts: { flexGrid: 1 },
        showDevices: false,
        customStyleManager: styleManager
      }
    },
    domComponents: {
      wrapperName: '根容器',
      oAssetsOnCreate: false
    },
    canvas: {
      styles: wwjs.loadjs.resolve([
        '@/bootstrap/4.1.3/css/bootstrap.min.css',
        '@/layerjs/0.6.2/layerjs-0.6.2.css'
      ]),
      scripts: wwjs.loadjs.resolve([
        '@/jquery/3.3.1/jquery.slim.min.js',
        '@/bootstrap/4.1.3/js/bootstrap.min.js',
        '@/layerjs/0.6.2/layerjs-0.6.2.min.js'
      ])
    }
  })
  wwInst.editor.wwinst = wwInst
  store.setup(wwInst.editor)
  ckeditor.setCustomRte(wwInst.editor)
  // console.log(wwInst.editor)
  let map = wwInst.editor.BlockManager.get('map')
  window.testMap = map
  console.log(map)
  window.testCat = wwInst.editor.BlockManager.getCategories()
  window.testBM = wwInst.editor.BlockManager

  // Add and beautify tooltips
  let buts = [['sw-visibility', '显示元素边界'], ['preview', '预览'], ['fullscreen', '全屏'], ['undo', '撤销'], ['redo', '反撤销'], ['canvas-clear', '清空']]
  var pn = wwInst.editor.Panels
  buts.forEach(function (item) {
    pn.getButton('options', item[0]).set('attributes', { title: wwjs.i18n(item[1]), 'data-tooltip-pos': 'bottom' })
  })
  // ['export-template', '保存', 'fa fa-eye', 'wwsave']['gjs-open-import-webpage', '导入'],
  pn.removeButton('options', 'export-template')
  pn.removeButton('options', 'gjs-open-import-webpage')

  buts = [['open-sm', '样式'], ['open-tm', '功能属性'], ['open-layers', '元素树'], ['open-blocks', '常用元素']]
  buts.forEach(function (item) {
    pn.getButton('views', item[0]).set('attributes', { title: wwjs.i18n(item[1]), 'data-tooltip-pos': 'bottom' })
  })
  var titles = document.querySelectorAll('*[title]')
  for (var i = 0; i < titles.length; i++) {
    var el = titles[i]
    var title = el.getAttribute('title')
    title = title ? title.trim() : ''
    if (!title) { break }
    el.setAttribute('data-tooltip', title)
    el.setAttribute('title', '')
  }
  // 需要调用set active来刷新tooltip.
  pn.getButton('options', 'sw-visibility').set('active', 1)
  pn.getButton('options', 'preview').set('active', 0)
  pn.getButton('options', 'fullscreen').set('active', 0)
  pn.getButton('options', 'undo').set('active', 0)
  pn.getButton('options', 'redo').set('active', 0)
  pn.getButton('options', 'canvas-clear').set('active', 0)
  wwInst.editor.on('load', () => {
    layer.setup(wwInst)
    components(wwInst)
    // stylebind(wwInst.editor)
    if (wwInst.props.storeread) {
      wwInst.editor.load(res => {
        console.log('Load callback with res=', res)
        onEditorLoaded(wwInst)
      })
    } else {
      onEditorLoaded(wwInst)
    }
  })
  // wwInst.editor.BlockManager
}

export default {
  init: initGrapes,
  loadDep: store.loadDep,
  switchTo: layer.switchTo
}
